<template>
  <div class="search-view">
    <div class="search-header" ref="searchHeader">
      <h1 class="a11y-hidden">웨이브</h1>
      <search-input v-if="searchCategory === 'all'"/>
      <view-more-editor-pick-header v-else-if="searchCategory === 'theme-list'" :title-list="titleList" :top-button-list="topButtonList" :close-fn="back"></view-more-editor-pick-header>
      <search-header-title v-else :search-category="searchCategory" :m-type="mType" />
    </div>
    <div :class="searchWrapperClassName" ref="searchWrapper">
      <div class="search-inner-wrapper" ref="searchInnerWrapper">
        <div v-if="keywordList.length > 0" class="list">
          <search-auto-complete-cell-list :keyword-list="keywordList" :thumbnail-info="thumbnailInfo" />
        </div>
        <template v-else>
          <div v-if="isKeywordResult">
            <search-keyword-result />
          </div>
          <template v-else>
            <search-tag-box />
            <search-popular-contents-list></search-popular-contents-list>
          </template>
        </template>
      </div>
    </div>
</div>
</template>
<script>
import SearchTagBox from '@/components/search/SearchTagBox'
import { EventBus } from '@/components/eventbus/EventBus'
import { get } from 'lodash'
import { mapMutations } from 'vuex'
import SearchKeywordResult from '@/components/search/SearchKeywordResult'
import { isNaverBrowser, isTablet } from '@/common/util/ua'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import SearchAutoCompleteCellList from '@/components/search/SearchAutoCompleteCellList'
import SearchInput from '@/components/search/SearchInput'
import SearchHeaderTitle from '@/components/search/SearchHeaderTitle'
import {
  SEARCH_KEYWORD_VIEW_MODE,
  SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO, SEARCH_EDITORPICK
} from '@/common/util/eventbus.const'
import SearchPopularContentsList from '@/components/search/SearchPopularContentsList'
import { removePrefixEmptyString } from '@/common/util/common'
import ViewMoreEditorPickHeader from '@/components/header/template/ViewMoreEditorPickHeader'
export default {
  name: 'Search',
  props: ['closeSearch'],
  components: {
    SearchHeaderTitle,
    SearchKeywordResult,
    SearchPopularContentsList,
    SearchTagBox,
    SearchAutoCompleteCellList,
    SearchInput,
    ViewMoreEditorPickHeader
  },
  data () {
    return {
      isSearchKeyword: false,
      keywordList: [],
      isBottomTab: get(this.$route, 'query.bt', 'y') !== 'n',
      searchCategory: 'all',
      isAutoCompleteContentsList: false,
      mType: 'all',
      thumbnailInfo: {},
      isKeywordResult: false,
      titleList: [],
      topButtonList: []
    }
  },
  computed: {
    searchWrapperClassName () {
      let className = 'search-wrapper'
      if (this.searchCategory !== 'all') {
        if (this.searchCategory === 'theme-list') {
          className += ' with-editorpick-hd'
        } else {
          className += ' search-list'
        }
      }

      if (isNaverBrowser() && isTablet()) {
        className += ' naver-in-ios'
      }
      return className
    }
  },
  methods: {
    ...mapMutations([ SET_CURRENT_MENU, 'showNavigationMenu', 'hideNavigationMenu' ]),
    keywordSearchViewSetting ({ isKeywordResult = false }) {
      this.isKeywordResult = isKeywordResult
    },
    searchAutoCompleteKeywordListInfo ({ keywordList, thumbnailInfo }) {
      this.keywordList = keywordList
      this.thumbnailInfo = thumbnailInfo
    },
    init () {
      this.searchCategory = get(this.$route, 'query.searchCategory', 'all')
      this.mType = get(this.$route, 'query.mType', 'all')
      if (get(this.$route, 'query.searchWord', '') === '') {
        this.keywordList = []
        this.isKeywordResult = false
      } else {
        this.isKeywordResult = true
      }
    },
    editorPickHeaderSetting ({ titleList, topButtonList }) {
      this.titleList = titleList
      this.topButtonList = topButtonList
    },
    back () {
      this.$router.back()
      this.searchCategory = 'all'
      this.titleList = []
      this.topButtonList = []
    }
  },
  created () {
    this.init()
    this[SET_CURRENT_MENU]('search')
    this.isSearchKeyword = removePrefixEmptyString(get(this.$route, 'query.searchWord', get(this.$route, 'query.keyword', ''))).length > 0
    if (!this.isBottomTab) {
      this.hideNavigationMenu()
    }
    this.isKeywordResult = get(this.$route, 'query.searchWord', '') !== ''
    EventBus.$on(SEARCH_KEYWORD_VIEW_MODE, this.keywordSearchViewSetting)
    EventBus.$on(SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO, this.searchAutoCompleteKeywordListInfo)
    EventBus.$on(SEARCH_EDITORPICK, this.editorPickHeaderSetting)
  },
  watch: {
    $route () {
      this.init()
    }
  },
  beforeDestroy () {
    EventBus.$off(SEARCH_KEYWORD_VIEW_MODE, this.keywordSearchViewSetting)
    EventBus.$off(SEARCH_AUTO_COMPLETE_KEYWORD_LIST_INFO, this.searchAutoCompleteKeywordListInfo)
    EventBus.$off(SEARCH_EDITORPICK, this.editorPickHeaderSetting)
  }
}
</script>
<style lang="css" src="@/assets/new-css/search.css"></style>
